import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15b3669e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sibling-member-node-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "full-sibling-connector" }, null, -1))

import { onMounted, onUpdated, ref } from "vue";
import FamilyMember from "@/bll/models/FamilyMember.mjs";
import MemberNode from "./MemberNode.vue";
import TreeUtils from "@/bll/tree_utils.mjs";
import GenerationComponent from "./GenerationComponent.vue";

interface Props {
  siblings: FamilyMember[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FullSiblingComponent',
  props: {
    siblings: {}
  },
  setup(__props: any) {



const container = ref();

onMounted(() => {
  configureComponent();
});

onUpdated(() => {
  configureComponent();
});

function configureComponent() {
  const siblingListItems = container!.value.querySelectorAll(
    ":scope > .full-sibling-list-item"
  );

  let lastSiblingListItem = null;

  for (const [index, currentSibling] of siblingListItems.entries()) {
    // We don't need to calculate width of connector for last siblingListItem
    if (index == siblingListItems.length - 1) {
      lastSiblingListItem = currentSibling;
      break;
    }

    const nextSibling = siblingListItems[index + 1];

    const currentSiblingMemberNode = getNodeContainer(currentSibling);
    const nextSiblingMemberNode = getNodeContainer(nextSibling);

    const connector = getConnector(currentSibling);

    connector.style.width =
      nextSiblingMemberNode.getBoundingClientRect().left -
      currentSiblingMemberNode.getBoundingClientRect().right +
      "px";
  }

  const selfNode = document.querySelector("#self-node");
  const lastSiblingMemberNode = getNodeContainer(lastSiblingListItem);
  const lastSiblingConnector = getConnector(lastSiblingListItem);

  // Need to add delay for nodes to properly be laid out before calculating the position and setting the connector width
  setTimeout(() => {
    lastSiblingConnector.style.width =
      selfNode!.getBoundingClientRect().left -
      lastSiblingMemberNode.getBoundingClientRect().right +
      "px";
  }, 10);
}

function getNodeContainer(container: HTMLElement): HTMLElement {
  return container.querySelector(":scope .node-container") as HTMLElement;
}

function getConnector(container: HTMLElement): HTMLElement {
  return container.querySelector(
    ":scope .full-sibling-connector"
  ) as HTMLElement;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    id: "full-siblings-container",
    ref_key: "container",
    ref: container
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siblings, (sibling) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "full-sibling-list-item",
        key: sibling.name
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(MemberNode, {
            member: sibling,
            "display-top-bar": false,
            "display-bottom-bar": _unref(TreeUtils).getDescendents(sibling).length > 0
          }, null, 8, ["member", "display-bottom-bar"]),
          _hoisted_2
        ]),
        (_unref(TreeUtils).getDescendents(sibling).length > 0)
          ? (_openBlock(), _createBlock(GenerationComponent, {
              key: 0,
              "family-members": _unref(TreeUtils).getDescendents(sibling),
              "is-ascending": false,
              "is-ascention-allowed": false
            }, null, 8, ["family-members"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 512))
}
}

})